// We keep these functions to avoid breaking imports in other files
export const fmtBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(v) || 0);

export const formatError = (e) => {
  if (!e) return "Erro desconhecido";
  if (typeof e === "string") return e;
  return e.message || e.error_description || e.msg || "Erro inesperado";
};

// Mock supabase object just in case it's imported somewhere (it shouldn't be used)
export const supabase = {
  auth: {},
  from: () => ({})
};
